<template>
  <tr class="panel-row furniturepanel-row" v-click-outside="validateAmount">
    <td class="index">

      <div class="index-invalid" v-if="panelInvalid">
        <font-awesome-icon icon="exclamation-triangle" class="font-awesome-icon invalid-panel"/>
      </div>

      <template v-else>
        {{ panel.id }}
      </template>
    </td>
    <td class="length">
      <input placeholder="mm" disabled type="text" v-model="lengthValue" class="form-control"/>
    </td>
    <td class="width">
      <v-select :id="'width-' + panel.id" ref="width" placeholder="mm" v-model="widthValue" :options="widthChoices" :clearable="false" :searchable="false"></v-select>
      <b-tooltip :show="widthInvalid" id="widthTooltip" ref="widthTooltip" :target="() => $refs['width']" variant="danger" placement="bottom" triggers="manual">{{ widthMessage }}</b-tooltip>
    </td>
    <td class="amount">
      <v-select :id="'amount-' + panel.id" ref="amount" placeholder="st" v-model="amountValue" :options="amountChoices" :clearable="false" :searchable="false"></v-select>
      <b-tooltip :show="amountInvalid" id="amountTooltip" ref="amountTooltip" :target="() => $refs['amount']" variant="danger" placement="bottom" triggers="manual">{{ amountMessage }}</b-tooltip>
    </td>
    <td class="priceinfo">
      <input placeholder="" disabled type="text" v-model="priceInfo" class="form-control justify-content-center"/>
    </td>
    <td class="checkbox l1">
      <input type="checkbox" checked disabled class="checkbox-side form-control"/>
      <label></label>
    </td>
    <td class="checkbox l2">
      <input type="checkbox" checked disabled class="checkbox-side form-control"/>
      <label></label>
    </td>
    <td class="actions">
      <template>
        <img src="images/icon-add-row.svg" :id="'copy-row-' + panel.id" ref="copy-row" class="font-awesome-icon action copy-row svg-inline--fa fa-w-18" @click="insert(panel)"/>
        <b-tooltip :target="() => $refs['copy-row']">Regel invoegen</b-tooltip>
        <font-awesome-icon :id="'trash-row-' + panel.id" ref="trash-row" class="font-awesome-icon action trash-row" @click="trashPanel(panel)" icon="trash-alt"/>
        <b-tooltip :target="() => $refs['trash-row']">Regel verwijderen</b-tooltip>
      </template>
    </td>
  </tr>
</template>

<script>
  import { REMOVE_PANEL, MUTATE_PANELS, SAVE_ORDER_LOCAL_STORAGE, MUTATE_CALCULATING_STATUS } from '../../../store/types'
  import vClickOutside from 'v-click-outside'
  import { panelValidation } from '../../../mixins/panel-validation'
  import { EventBus } from '../../../bus'

  export default {
    props: ['panel'],
    data() {
      return {
        width: null,
        widthInvalid: false,
        widthMessage: null,
        amount: null,
        amountInvalid: false,
        amountMessage: null
      }
    },
    directives: {
      clickOutside: vClickOutside.directive
    },
    mixins: [panelValidation],
    computed: {
      widthValue: {
        get() {
          return !this.panel.width ? false : this.panel.width
        },
        set(value) {
          this.width = value.code
          this.panel.width = value.code

          this.resetCalculateStatus()
          this.saveCart()
        }
      },
      amountValue: {
        get() {
          return !this.panel.amount ? false : this.panel.amount
        },
        set(value) {
          this.amount = value.code
          this.panel.amount = value.code

          this.resetCalculateStatus()
          this.saveCart()
        }
      },
      panels() {
        return !this.$store.getters.panels ? [] : this.$store.getters.panels
      },
      panelInvalid() {
        return this.widthInvalid === true || this.amountInvalid === true
      },
      cart() {
        return !this.$store.getters.cart ? null : this.$store.getters.cart
      },
      finishCode() {
        return !this.$store.getters.materialFinish ? null : this.$store.getters.materialFinish.code;
      },
      furnitureproducts() {
        if (this.$store.getters.filterThird) {
          let filterDeliveryProgram = this.$store.getters.filterDeliveryProgram
          let filterThird = this.$store.getters.filterThird !== 'geen' ? this.$store.getters.filterThird : ''

          return this.$store.getters.products.filter((product) => (product.deliveryprogram === filterDeliveryProgram  && product.filter_3 === filterThird))
        }

        return []
      },
      product() {
        let width = this.panel.width
        let products = this.furnitureproducts.filter((product) => (product.width === width))
        // Get the correct product, based on choosen finish && product.sku
        if (products.length > 1 && this.finishCode) {
          let finish = this.finishCode.substr(this.finishCode.length - 1)
          if (finish === '1') {
            products = products.filter((product) => (product.sku.substr(product.sku.length - 1) === '1'))
          } else {
            products = products.filter((product) => (product.sku.substr(product.sku.length - 1) !== '1'))
          }
        }

        return products.length === 0 ? null : products[0]
      },
      lengthValue() {
        this.length = this.furnitureproducts.length === 0 ? null : this.furnitureproducts[0].length
        this.panel.length = this.length
        return this.length
      },
      widthChoices() {
        if (this.$store.getters.filterThird) {
          // Sort by width
          let products = this.furnitureproducts
          let filters = [...new Set(products.sort((a, b) => (parseInt(a.width) > parseInt(b.width)) ? 1 : ((parseInt(b.width) > parseInt(a.width)) ? -1 : 0)))]

          let options = [...new Set()]
          filters.forEach((filter) => {
            if (options.findIndex(option => option.code === filter.width) < 0) {
              options.push({
                code: filter.width,
                label: filter.width + ' mm'
              })
            }
          }, [options])

          return options
        }

        return []
      },
      amountChoices() {
        let values = [...Array(23).keys()].map( i => i+1)
        if (this.product) {
          if (this.product.price24) {
            values.push(24)
          }
          if (this.product.price25) {
            values.push(25)
          }
          if (this.product.price50) {
            values.push(50)
          }
        }

        let options = [...new Set()]
        values.forEach((key) => {
          options.push({
            code: key,
            label: key + ' stuks'
          })
        }, [options])
        return options
      },
      priceInfo() {
        if (!this.product) {
          return ''
        } else if (this.panel.amount && this.panel.amount <= 23) {
          return '€ ' + this.product.price + ' p/stuk'
        } else if (this.panel.amount == 24) {
          return '€ ' + this.product.price24 + ' p/stuk'
        } else if (this.panel.amount == 25) {
          return '€ ' + this.product.price25 + ' p/stuk'
        } else if (this.panel.amount == 50) {
          return '€ ' + this.product.price50 + ' p/stuk'
        } else {
          return ''
        }
      }
    },
    methods: {
      // Managing panels
      copy(panel) {
        let panelToCopy = this.panels.find((x) => {
          return x.id === panel.id
        })

        if (panelToCopy) {
          let newPanel = JSON.parse(JSON.stringify(panel))
          newPanel.id = this.panels.length + 1
          this.panels.push(newPanel)
        }
      },
      insert(panel) {
        if (panel.valid) {
          let newPanel = { id: panel.id + 1, length: null, width: null, amount: null, l1: true, l2: true, b1: false, b2: false, reference: null, valid: null }

          // create new array & insert the selected panel
          let newpanels = [...this.panels]
          newpanels.splice(panel.id, 0, newPanel)
          newpanels.map(function (x, i) {
            x.id = i + 1
          })
          console.log('np', newpanels)
          this.$store.commit(MUTATE_PANELS, newpanels)
        }
      },
      trashPanel(panel) {
        if (panel.width || panel.amount || panel.l1 || panel.l2 || panel.b1 || panel.b2) {
          this.resetCalculateStatus()
        }
        this.$store.dispatch(REMOVE_PANEL, panel)
      },
      saveCart() {
        if (this.panel.valid) {
          this.$store.dispatch(SAVE_ORDER_LOCAL_STORAGE, this.cart)
        }
      },
      resetCalculateStatus() {
        if (this.panel.valid === true) {
          this.$store.commit(MUTATE_CALCULATING_STATUS, null)
        }
      },
      // Validation
      validateRow() {
        this.validateFormat()
      },
      validateAmount() {
        // No validation needed until switching sections or calculating price
        this.isValid()
      },
      validateFormat() {
        // No validation needed until switching sections or calculating price
        this.isValid()
      },
      isValid() {
        if (this.panel.width === null || this.panel.amount === null) {
          this.panel.valid = null
        } else {
          this.panel.valid = this.widthInvalid === false && this.amountInvalid === false
        }
      }
    },
    updated() {
      if (this.product) {
        // Deselect if option no longer available
        if (this.panel.width && this.widthChoices.findIndex(option => option.code === this.panel.width) < 0) {
          this.width = null
          this.panel.width = null
        }

        // Deselect amount if option no longer available
        if (this.panel.amount && this.amountChoices.findIndex(option => option.code === this.panel.amount) < 0) {
          this.amount = null
          this.panel.amount = null
        }
      } else {
        // no product found, reset fields
        this.width = null
        this.panel.width = null
        this.amount = null
        this.panel.amount = null
      }
    },
    created() {
      EventBus.$on('validate-row', data => {
        this.validateRow()
      })
    },
    mounted() {
      if (this.panel.width) {
        this.width = this.panel.width
      }
      if (this.panel.amount) {
        this.amount = this.panel.amount
      }
      this.validateRow()
    }
  }
</script>

<style lang="scss" scoped>
  .btn-danger {
    margin-left: 5px;
  }

  .form-control {
    padding: 0px;

    &.reference {
      padding: 3px;
    }

    &:disabled {
      background-color: #f2f2f2;
    }
  }

  .tool .furniturepanel-rows input.checkbox-side[type=checkbox]:disabled + label {
    background-color: #f2f2f2;
  }
</style>
